const grades = { 
  grade_b: 'Agen',
  grade_c: 'Non Agen'
}

export default (grade = '') => grades[grade]